import Icon from '@material-ui/icons/Pages';

import Create from './Create';
import Edit from './Edit';
import List from './List';
import Show from './Show';

export default {
  name: 'page',
  icon: Icon,
  list: List,
  show: Show,
  create: Create,
  edit: Edit,
};
